import React from "react";

export default function InfoCTR() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-12">
      <div className="flex flex-col md:flex-row text-center md:text-left justify-center items-center gap-4">
        <img
          src="/images/home/plane.png"
          alt="Plane"
          width={40}
          height={40}
          className="object-contain w-[40px] h-[40px] md:w-[50px] md:h-[50px]"
        />
        <div>
          <h3 className="text-[#606060] uppercase font-semibold text-[17px]">
            17+ Tours & UAE Experiences
          </h3>
          <p className="text-[#606060] text-[13px]">Desert safaris, city tours, dhow cruises, day trips & adventure</p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row text-center md:text-left justify-center items-center gap-4">
        <img
          src="/images/home/credit-card.png"
          alt="Credit Card"
          width={40}
          height={40}
          className="object-contain w-[40px] h-[40px] md:w-[50px] md:h-[50px]"
        />
        <div>
          <h3 className="text-[#606060] uppercase font-semibold text-[17px]">
            Best Price Guaranteed
          </h3>
          <p className="text-[#606060] text-[13px]">Find it cheaper elsewhere — we match it, no questions asked</p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row text-center md:text-left justify-center items-center gap-4">
        <img
          src="/images/home/contact.png"
          alt="Contact"
          width={40}
          height={40}
          className="object-contain w-[40px] h-[40px] md:w-[50px] md:h-[50px]"
        />
        <div>
          <h3 className="text-[#606060] uppercase font-semibold text-[17px]">
            5.0 ★ Rated on TripAdvisor
          </h3>
          <p className="text-[#606060] text-[13px]">60+ verified five-star reviews. Guides rated by name.</p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row text-center md:text-left justify-center items-center gap-4">
        <img
          src="/images/home/hand-shake.png"
          alt="Hand Shake"
          width={40}
          height={40}
          className="object-contain w-[40px] h-[40px] md:w-[50px] md:h-[50px]"
        />
        <div>
          <h3 className="text-[#606060] uppercase font-semibold text-[17px]">
            Trusted & Fully Licensed
          </h3>
          <p className="text-[#606060] text-[13px]">Licensed vehicles, insured tours & free travel insurance included</p>
        </div>
      </div>
    </div>
  );
}
